import { MCBPS040CountRequest } from 'types/MCBPS040/MCBPS040CountRequest'
import { MCBPS040SearchRequest } from 'types/MCBPS040/MCBPS040SearchRequest'
import request from 'utils/request'

export const initApi = () =>
  request({
    url: `/MCBPS040/init`,
    method: 'post'
  })

export const findApi = (param: MCBPS040SearchRequest) =>
  request({
    url: `/MCBPS040/find`,
    method: 'post',
    data: param
  })

export const selectUploadCountApi = (param: MCBPS040CountRequest) =>
  request({
    url: `/MCBPS040/selectUploadCount`,
    method: 'post',
    data: param
  })